import { Component, EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SensoresService {
  ruteRedirect: BehaviorSubject<any> = new BehaviorSubject<any>('metricas');
  constructor() {}

  /*setDrawerComponent(component: any) {
    this.drawerComponent.next(component);
  }*/
}
